export const houses = [
  {
    id: 'house-1',
    name: 'Villa Azur',
    model: 'Villa avec piscine & vue mer',
    type: 'Villa',
    location: 'Hyères, Côte d\'Azur',
    bedrooms: 4,
    bathrooms: 3,
    guests: 8,
    area: '200m²',
    pricePerDay: 890,
    image: 'https://public.readdy.ai/ai/img_res/edited_c270beeae6842b2547470406796dc7f8_42eee66e.jpg',
    gallery: [
      'https://public.readdy.ai/ai/img_res/edited_c270beeae6842b2547470406796dc7f8_42eee66e.jpg',
      'https://public.readdy.ai/ai/img_res/edited_da3eaa982d87dc2a2ac1157e1a865f61_42eee66e.jpg',
      'https://public.readdy.ai/ai/img_res/368ce3e433f6870aa058676cd0d66890.jpg'
    ],
    description: 'Une villa d\'exception avec vue panoramique sur la mer et piscine privée à débordement. Idéale pour des vacances de caractère en famille ou entre amis sur la Côte d\'Azur.',
    features: ['Piscine à débordement', 'Vue mer panoramique', 'Jardin tropical', 'Terrasse spacieuse', 'Cuisine équipée', 'Parking privé', 'Climatisation', 'WiFi haut débit'],
    amenities: 'Linge de maison fourni, ménage inclus à l\'arrivée'
  }
];
